/* tslint:disable */
/* eslint-disable */
/**
 * Yaway Workshop API
 * Yaway Workshop API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApiWorkshop1
 */
export interface ApiWorkshop1 {
    /**
     * 
     * @type {number}
     * @memberof ApiWorkshop1
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshop1
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof ApiWorkshop1
     */
    latitude: number;
    /**
     * 
     * @type {number}
     * @memberof ApiWorkshop1
     */
    longitude: number;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshop1
     */
    address?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshop1
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshop1
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiWorkshop1
     */
    county?: string;
}

export function ApiWorkshop1FromJSON(json: any): ApiWorkshop1 {
    return ApiWorkshop1FromJSONTyped(json, false);
}

export function ApiWorkshop1FromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiWorkshop1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'latitude': json['latitude'],
        'longitude': json['longitude'],
        'address': !exists(json, 'address') ? undefined : json['address'],
        'phone': !exists(json, 'phone') ? undefined : json['phone'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'county': !exists(json, 'county') ? undefined : json['county'],
    };
}

export function ApiWorkshop1ToJSON(value?: ApiWorkshop1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'latitude': value.latitude,
        'longitude': value.longitude,
        'address': value.address,
        'phone': value.phone,
        'description': value.description,
        'county': value.county,
    };
}

